<template>
  <div class="reactor-capacity-page p-4">
    <h2>Reactor Capacity</h2>
    <div v-if="loading" class="text-muted">Loading…</div>
    <div v-else-if="error" class="text-danger">{{ error }}</div>
    <div v-else>
      <b-card class="mb-3">
        <b-row>
          <b-col cols="6">
            <div class="text-muted small">Available (declared)</div>
            <div class="h4">{{ data.available_terahashes }} TH/s</div>
          </b-col>
          <b-col cols="6">
            <div class="text-muted small">Overcap buffer</div>
            <div class="h4">
              {{ (data.overcap_percentage * 100).toFixed(0) }}%
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="4">
            <div class="text-muted small">Sellable</div>
            <div>{{ data.sellable_th }} TH/s</div>
          </b-col>
          <b-col cols="4">
            <div class="text-muted small">Active sold</div>
            <div>{{ data.active_th_sold }} TH/s</div>
          </b-col>
          <b-col cols="4">
            <div class="text-muted small">Free</div>
            <div>{{ data.free_th }} TH/s</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header="Edit capacity" class="mb-3">
        <b-form @submit.prevent="save">
          <b-form-group label="AVAILABLE_TERAHASHES">
            <b-form-input
              v-model.number="form.available_terahashes"
              type="number"
              min="0"
            />
          </b-form-group>
          <b-form-group label="OVERCAP_PERCENTAGE (0.0 – 1.0)">
            <b-form-input
              v-model.number="form.overcap_percentage"
              type="number"
              step="0.01"
              min="0"
              max="1"
            />
          </b-form-group>
          <b-form-checkbox v-model="form.new_miners_enabled" class="mb-2">
            Retail buy page enabled (new_miners_enabled)
          </b-form-checkbox>
          <b-form-checkbox v-model="form.trial_miners_enabled" class="mb-3">
            Trial miners enabled
          </b-form-checkbox>
          <b-button type="submit" variant="primary" :disabled="saving">
            {{ saving ? "Saving…" : "Save" }}
          </b-button>
          <span v-if="saved" class="text-success ml-3">Saved.</span>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      loading: true,
      saving: false,
      saved: false,
      error: null,
      data: {},
      form: {
        available_terahashes: 0,
        overcap_percentage: 0,
        new_miners_enabled: false,
        trial_miners_enabled: false,
      },
    };
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = null;
      const res = await api.reactorAdminGetCapacity();
      if (!res.ok) {
        this.error = res.data.error
          ? res.data.error.message || "Failed to load"
          : "Failed to load";
      } else {
        this.data = res.data.result || {};
        this.form.available_terahashes = this.data.available_terahashes;
        this.form.overcap_percentage = this.data.overcap_percentage;
        this.form.new_miners_enabled = this.data.new_miners_enabled;
        this.form.trial_miners_enabled = this.data.trial_miners_enabled;
      }
      this.loading = false;
    },
    async save() {
      this.saving = true;
      this.saved = false;
      const res = await api.reactorAdminPatchCapacity(this.form);
      this.saving = false;
      if (!res.ok) {
        this.error = res.data.error
          ? res.data.error.message || "Save failed"
          : "Save failed";
      } else {
        this.saved = true;
        await this.load();
      }
    },
  },
};
</script>
